import React from 'react';
import { Route, Redirect } from 'react-router';
import asyncComponent from './../components/AsyncComponent';
import NotFound from './../components/NotFound';

const AsyncDocumentManager = asyncComponent(() =>
  import('./../containers/DocumentManager')
);

const AsyncDashboard = asyncComponent(() =>
  import('./../containers/Dashboard')
);

const AsyncUploadAnEinerReise = asyncComponent(() =>
  import('./../containers/UploadAnEinerReise')
);

const AsyncVoyageDetail = asyncComponent(() =>
  import('./../containers/VoyageDetail')
);

const AsyncUploadAnTermin = asyncComponent(() =>
  import('./../containers/UploadAnTermin')
);

const AsyncUploadAnBuchung = asyncComponent(() =>
  import('./../containers/UploadAnBuchung')
);

const AsyncAllgemeineDokumente = asyncComponent(() =>
  import('./../containers/AllgemeineDokumente')
);

const AsyncReiseverlauf = asyncComponent(() =>
  import('./../containers/Reiseverlauf')
);

const AsyncReiseverlaufDetail = asyncComponent(() =>
  import('./../containers/ReiseverlaufDetail')
);

const AsyncReiseverlaufEdit = asyncComponent(() =>
  import('./../containers/ReiseverlaufEdit')
);

const AsyncDocumentModules = asyncComponent(() =>
  import('./../containers/DocumentModules')
);

const AsyncReiseBeschreibungIndex = asyncComponent(() =>
  import('./../containers/Reisebeschreibung')
);

const AsyncReisebeschreibungDateAssignment = asyncComponent(() =>
  import('./../containers/Reisebeschreibung/DateAssignment')
);

const AsyncReisebeschreibungEdit = asyncComponent(() =>
  import('./../containers/Reisebeschreibung/Edit')
);

const AsyncLaenderinfo = asyncComponent(() =>
  import('./../containers/Laenderinfo')
);

const AsyncLaenderinfoEdit = asyncComponent(() =>
  import('./../containers/Laenderinfo/Edit')
);

export const AsyncCRUDEdit = asyncComponent(() =>
  import('./../containers/CRUD/Edit')
);

export const AsyncCRUDShow = asyncComponent(() =>
  import('./../containers/CRUD/Show')
);

export const AsyncCRUDList = asyncComponent(() =>
  import('./../containers/CRUD/List')
);

export const AsyncDocumentModuleAssignments = asyncComponent(() =>
  import('./../containers/DocumentModuleAssignments')
);

const AsyncCRUD = asyncComponent(() => import('./../containers/CRUD'));

export const componentMap = {
  alle_gruppen: null,
  buchungen: null,
  rechnungen: null,
  ausgaben: null,
  kunden: null,
  erv_datev: null,
  anfragen: null,
  allgemeine_verwaltung: null,
  dubletten: null,
  buchhaltung: null,
  wi: null,
  v2: AsyncDocumentManager,
  'v2/dashboard': AsyncDashboard,
  'v2/allgemeiner_upload': AsyncAllgemeineDokumente,
  'v2/upload_an_einer_reise': AsyncUploadAnEinerReise,
  'v2/upload_an_einem_termin': AsyncUploadAnTermin,
  'v2/upload_an_einer_buchung': AsyncUploadAnBuchung,
  'v2/super_admin_country_info_templates': AsyncLaenderinfoEdit,
  'v2/super_admin_country_infos': AsyncLaenderinfo,
  'v2/country_infos': AsyncLaenderinfo,
  'v2/voyage_content': AsyncReiseBeschreibungIndex,
  'v2/mailversand': null,
  'v2/reiseverlauf': AsyncReiseverlauf
};

const constantRoutes = [
  <Route
    key="route_voyage_detail"
    exact
    path={`/v2/voyages/:id`}
    component={AsyncVoyageDetail}
  />,
  <Route
    key="route_voyagetimeline_detail"
    exact
    path={`/v2/reiseverlauf/:id`}
    component={AsyncReiseverlaufDetail}
  />,
  <Route
    key="route_voyagetimeline_edit"
    exact
    path={`/v2/reiseverlauf/:id/edit`}
    component={AsyncReiseverlaufEdit}
  />,
  <Route
    key="route_document_modules_index"
    exact
    path="/v2/(last_minute_unterlagen|Laenderinformationen)"
    component={AsyncDocumentModules}
  />,
  <Route key="route_crud" path="/v2/crud/:type" component={AsyncCRUD} />,
  <Route
    key="route_document_module_assignments"
    exact
    path="/v2/document_manager/:id/document_module_assignments"
    component={AsyncDocumentModuleAssignments}
  />,
  <Route
    key="companies_agency_addresses"
    exact
    path={'/v2/agency_addresses'}
    render={() => <Redirect to={'/v2/crud/agency_addresses'} />}
  />,
  <Route
    key="companies_archiv_agency_addresses"
    exact
    path={'/v2/archiv_agency_addresses'}
    render={() => <Redirect to={'/v2/crud/archiv_agency_addresses'} />}
  />,
  <Route
    key="companies_hotel_addresses"
    exact
    path={'/v2/hotel_addresses'}
    render={() => <Redirect to={'/v2/crud/hotel_addresses'} />}
  />,
  <Route
    key="companies_archiv_hotel_addresses"
    exact
    path={'/v2/archiv_hotel_addresses'}
    render={() => <Redirect to={'/v2/crud/archiv_hotel_addresses'} />}
  />,
  <Route
    key="companies_guide_addresses"
    exact
    path={'/v2/guide_addresses'}
    render={() => <Redirect to={'/v2/crud/guide_addresses'} />}
  />,
  <Route
    key="companies_archiv_guide_addresses"
    exact
    path={'/v2/archiv_guide_addresses'}
    render={() => <Redirect to={'/v2/crud/archiv_guide_addresses'} />}
  />,
  <Route
    key="companies_airlines"
    exact
    path={'/v2/airline_addresses'}
    render={() => <Redirect to={'/v2/crud/airline_addresses'} />}
  />,
  <Route
    key="companies_archiv_airlines"
    exact
    path={'/v2/archiv_airline_addresses'}
    render={() => <Redirect to={'/v2/crud/archiv_airline_addresses'} />}
  />,
  <Route
    key="super_admin_country_info_edit"
    exact
    path={'/v2/super_admin_country_infos/:id/edit'}
    component={AsyncLaenderinfoEdit}
  />,
  <Route
    key="country_infos_edit"
    exact
    path={'/v2/country_infos/:id/edit'}
    component={AsyncLaenderinfoEdit}
  />,
  <Route
    key="voyage_content_date_assignment"
    exact
    path={'/v2/voyage_content/:id/assignments'}
    component={AsyncReisebeschreibungDateAssignment}
  />,
  <Route
    key="voyage_content_edit"
    exact
    path={'/v2/voyage_content/:id/edit'}
    component={AsyncReisebeschreibungEdit}
  />,
  <Route
    key="index_route"
    exact
    path={'/'}
    render={() => <Redirect to={'/v2/dashboard'} />}
  />
  // <Route
  //   key="index_route"
  //   exact
  //   path={'/'}
  //   render={() => <Redirect to={'/v2/allgemeiner_upload'} />}
  // />
];

export const generateRoutes = navigation => {
  let routes = [];
  Object.entries(componentMap).map(key => {
    routes = [
      ...routes,
      <Route
        key={'route_' + key[0]}
        exact
        path={`/${key[0]}`}
        component={key[1] ? key[1] : NotFound}
      />
    ];
    return true;
  });
  routes = [...routes, ...constantRoutes];
  return routes;
};



// WEBPACK FOOTER //
// ./src/utils/RoutesGenerator.js